export const DEFAULT_LAST_CONSUMED_MESSAGE_INDEX = -1;

export const UNREAD_COUNT_DISPLAY_THRESHOLD = 99;

export const BEAMER_CHANNEL_ID = 'beamer-newsfeed';

export const BEAMER_CHANNEL_TITLE = 'BEEM Neuigkeiten';
